import React, { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Country } from 'country-state-city';
import PhoneInput, {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input';
import { useFormik } from 'formik';
import { string_required, email } from '../../../validation/validationSchema';
import Flag from 'react-world-flags';
import * as Yup from 'yup';
import { addMember, updateMember } from '../../../api-services';
const initialState = {
  firstname: '',
  lastname: '',
  country: '',
  email: '',
  phone: '',
  password: '',
  confirm_password: '',
  push_notification: false,
  email_notification: false,
  sms_notification: false,
  auto_topup: false,
};

const AddMemberModal = ({
  setOpenModal,
  openModal,
  editData = {},
  setEditData,
}) => {
  const isEdit = editData && Object.keys(editData).length > 0;
  const [initialValues, setInitialValues] = useState(initialState);

  const [countryList, setCountryList] = useState([]);
  const [isPhoneError, setPhoneError] = useState(false);
  const [presentCountry, setPresentCountryData] = useState({});
  const queryClient = useQueryClient();

  const validationSchema = Yup.object({
    country: string_required,
    firstname: string_required,
    lastname: string_required,
    email: email,
    phone: string_required,
    password: Yup.string()
      .required('password is required')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
        'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character, example: Abcd@123',
      ),
    confirm_password: Yup.string().when('password', {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string()
        .oneOf([Yup.ref('password')], 'Password must be same')
        .required('This feild is required'),
    }),
  });

  const handleSubmitForm = async (values) => {
    if (isEdit) {
      const {
        push_notification,
        email_notification,
        sms_notification,
        auto_topup,
        ...rest
      } = values;
      const payload = {
        ...rest,
        settings: {
          push_notification: push_notification ? 1 : 0,
          email_notification: email_notification ? 1 : 0,
          sms_notification: sms_notification ? 1 : 0,
          auto_topup: auto_topup ? 1 : 0,
        },
      };
      await mutateAsyncUpdate(payload);
    } else {
      const {
        push_notification,
        email_notification,
        sms_notification,
        auto_topup,
        ...rest
      } = values;
      const payload = {
        ...rest,
        // settings: {
        //   push_notification: push_notification ? 1 : 0,
        //   email_notification: email_notification ? 1 : 0,
        //   sms_notification: sms_notification ? 1 : 0,
        //   auto_topup: auto_topup ? 1 : 0,
        // },
      };
      await mutateAsync1(payload);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: !isEdit && validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const { isLoading: isLoadingAddMember, mutateAsync: mutateAsync1 } =
    useMutation('addMember', addMember, {
      onSuccess: (data) => {
        setOpenModal(false);
        setPhoneError(false);
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('UserListing');
          formik.resetForm();
        });
      },
      onError: (error) => {
        setPhoneError(false);
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });
  const { isLoading: isLoadingUpdateMember, mutateAsync: mutateAsyncUpdate } =
    useMutation('updateMember', updateMember, {
      onSuccess: (data) => {
        setOpenModal(false);
        setPhoneError(false);
        setEditData({})
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('UserListing');
          formik.resetForm();
        });
      },
      onError: (error) => {
        setPhoneError(false);
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });

  useEffect(() => {
    const countries = Country.getAllCountries();
    setCountryList(countries);
    return () => formik.resetForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setInitialValues(editData);
    }
  }, [editData]);

  useEffect(() => {
    if (countryList && countryList.length > 0) {
      let presentCountry = countryList.filter(
        (c) => c.isoCode === formik.values.country,
      );
      if (presentCountry && presentCountry.length > 0) {
        setPresentCountryData(presentCountry[0]);
      }
    }
  }, [formik.values.country]); // eslint-disable-line

  useEffect(() => {
    if (countryList && countryList.length > 0) {
      setPresentCountryData(countryList[0]);
    }
  }, [countryList]);

  const handleClose = () => {
    setOpenModal(false);
    setPhoneError(false);
    setEditData({});
    formik.resetForm();
  };

  useEffect(() => {
    if (formik?.values?.phone) {
      if (!isEdit) {
        if (
          !isPossiblePhoneNumber(formik?.values?.phone) ||
          !isValidPhoneNumber(formik?.values?.phone)
        ) {
          setPhoneError(true);
        } else {
          setPhoneError(false);
        }
      }
    } else {
      setPhoneError(false);
    }
  }, [formik?.values?.phone]);

  // useEffect(() => {
  //   console.log('formik.values', formik.values.settings);
  // }, [formik.values.settings]);

  return (
    <Modal
      size="md"
      centered
      show={openModal}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            {isEdit ? 'Edit' : 'Add'} User
          </h5>
        </div>

        <div className="modal-body">
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Firstname"
                name="firstname"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstname}
              />
              {formik.touched.firstname && formik.errors.firstname ? (
                <div className="error_required">{formik.errors.firstname}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Lastname"
                name="lastname"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastname}
              />
              {formik.touched.lastname && formik.errors.lastname ? (
                <div className="error_required">{formik.errors.lastname}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                name="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                disabled={isEdit}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="error_required">{formik.errors.email}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="country"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.country}
                disabled={isEdit}
              >
                <option value="">Please select country</option>
                {countryList?.map((c, i) => (
                  <option value={c.isoCode} key={i}>
                    {c.name}
                  </option>
                ))}
              </select>
              {formik.touched.country && formik.errors.country ? (
                <div className="error_required">{formik.errors.country}</div>
              ) : null}
            </div>
          </div>

          {formik.values.country ? (
            <div className="form-group input_control input_control--gap">
              <div className="w-100 custom-phone-input flag-none">
                {!isEdit && (
                  <span className="pin_code">
                    {presentCountry && presentCountry.phonecode
                      ? `+${presentCountry.phonecode}`
                      : null}
                  </span>
                )}

                <span className="input_flag">
                  {presentCountry && presentCountry.isoCode ? (
                    <Flag code={presentCountry.isoCode} />
                  ) : null}
                </span>

                <PhoneInput
                  defaultCountry={formik?.values?.country}
                  // international={false}
                  // addInternationalOption={false}
                  disabled={isEdit}
                  withCountryCallingCode={isEdit ? true : false}
                  countryCallingCodeEditable={false}
                  internationalIcon={() => (
                    <span>
                      <i className="fa fa-phone  icon-circle bg-danger"></i>
                    </span>
                  )}
                  type="text"
                  name="phone"
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                  limitMaxLength={13}
                  onChange={(phone) => formik.setFieldValue('phone', phone)}
                  className="form-control MuiInputBase-input MuiInput-input"
                />
                {(formik.touched.phone && formik.errors.phone) ||
                  !isEdit && isPhoneError ? (
                  <div className="error_required">
                    {formik.errors.phone || 'phone number not valid'}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          {isEdit && (
            <div className="form-group input_control input_control--gap">
              <div className="w-100">
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Please provide address...."
                  name="address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                />
                {formik.touched.address && formik.errors.address ? (
                  <div className="error_required">{formik.errors.address}</div>
                ) : null}
              </div>
            </div>
          )}
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Password"
                name="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="error_required">{formik.errors.password}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Confirm Password"
                name="confirm_password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirm_password}
              />
              {formik.touched.confirm_password &&
                formik.errors.confirm_password ? (
                <div className="error_required">
                  {formik.errors.confirm_password}
                </div>
              ) : null}
            </div>
          </div>

          {isEdit && (
            <>
              <div className="form-group input_control input_control--gap">
                <div className="w-100">
                  <h5>User settings</h5>
                </div>
              </div>
              <Row>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex">
                        <input
                          type="checkbox"
                          name="push_notification"
                          onChange={formik.handleChange}
                          value={true}
                          checked={formik.values.push_notification}
                        />
                        &nbsp; Push notification
                      </label>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex">
                        <input
                          type="checkbox"
                          name="email_notification"
                          onChange={formik.handleChange}
                          value={true}
                          checked={formik.values.email_notification}
                        />
                        &nbsp; Email notification
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex">
                        <input
                          type="checkbox"
                          name="sms_notification"
                          onChange={formik.handleChange}
                          value={true}
                          checked={formik.values.sms_notification}
                        />
                        &nbsp; Sms notification
                      </label>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex">
                        <input
                          type="checkbox"
                          name="auto_topup"
                          onChange={formik.handleChange}
                          value={true}
                          checked={formik.values.auto_topup}
                        />
                        &nbsp; Auto topup
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClose()}
          >
            Close
          </button>

          <button
            type="submit"
            disabled={isPhoneError}
            className="btn btn-dark-blue"
          >
            {isLoadingAddMember || isLoadingUpdateMember
              ? 'Please Wait...'
              : 'Submit'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddMemberModal;
